var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7273 0.64557C23.2545 1.04722 23.3562 1.80017 22.9546 2.32734L10.1546 19.1273C9.94471 19.4028 9.62608 19.5741 9.28058 19.5974C8.93508 19.6206 8.59638 19.4935 8.35152 19.2486L1.15152 12.0486C0.682892 11.58 0.682892 10.8202 1.15152 10.3516C1.62015 9.88293 2.37995 9.88293 2.84858 10.3516L9.07767 16.5807L21.0455 0.872836C21.4472 0.345671 22.2001 0.24392 22.7273 0.64557Z",
    fill: "#21BF54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.dd2b71d9f5d7c9aac0a66157ee7c075e.svg";
export { ForwardRef as ReactComponent };